var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('md-switch',{attrs:{"model":_vm._value},on:{"change":_vm.change}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }